export default function (state, val) {
    let filter = state.filters.filter(i => {
        return i.id === val.id;
    })[0];
    for (let k in val) {
        switch (k) {
            case 'CategoryId':
                filter.CategoryId = val;
                filter.PaymentTypeIds = '';
                filter.CashList = '';
                filter.PaymentAccountList = '';
                break;
            case 'Contragent':
                let type = '';
                switch (val.type) {
                    case 'client':
                        type = 5;
                        break;
                    case 'partner':
                        type = 3;
                        break;
                    case 'partnerLegal':
                        type = 6;
                        break;
                }
                filter.ContragentID = val.value ? val.value : '';
                filter.ContragentName = val.label ? val.label : '';
                filter.ContragentType = type;
                break;
            default:
                if (typeof filter[k] !== 'undefined') filter[k] = val[k];
        }
    }
}